import * as React from 'react';

import { PinnedHotelViewModel } from 'models';

import { UitkCardFeaturedHeader } from 'uitk-react-cards';

export interface TitleHeadingProps {
  headingInfo: PinnedHotelViewModel | undefined;
}

export const TitleHeading: React.FunctionComponent<TitleHeadingProps> = ({ headingInfo }) => (
  <UitkCardFeaturedHeader
    className="title__header uitk-type-300 uitk-type-medium"
    title={{ text: headingInfo?.heading || '' }}
  ></UitkCardFeaturedHeader>
);
